var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHuman = function SvgHuman(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 15.1c3.6 0 6.5-2.9 6.5-6.5s-2.9-6.5-6.5-6.5S8.4 5 8.4 8.6c.1 3.7 3 6.5 6.5 6.5m0-10.7c2.4 0 4.3 1.9 4.3 4.3S17.3 13 14.9 13s-4.3-1.9-4.3-4.3c.1-2.4 2-4.3 4.3-4.3M25.2 24.9c-.2-4.6-4-8.3-8.6-8.3h-3.2c-4.8 0-8.6 3.9-8.6 8.6 0 1.2 1 2.2 2.2 2.2h16c1.2 0 2.2-1 2.2-2.2zm-18.3.19999999999999998c0-3.6 2.9-6.4 6.4-6.4h3.2c3.5 0 6.4 2.9 6.4 6.4zm18 .09999999999999998",
    className: "st0"
  })));
};
export default SvgHuman;